import React, { useState } from 'react'
import {
    addNewTrentIcon,
    DownArrowSelect,
    PaginationLeftArrow,
    PaginationRightArrow
} from '../assets/icons'

const opportunitiesData = [
    {
        opportunity: 'Enterprise Plan Upgrade',
        description: 'Customer interested in advanced analytics and custom reporting features',
        value: '$15,000',
        probability: 0.5,
        stage: 'Proposal',
        expectedClose: 'Oct 15, 2025',
        owner: 'Sarah Johnson',
        DataStatus: 'Upsell'
    },
    {
        opportunity: 'Performance Management Module',
        description: 'HR Manager expressed interest in performance review automation',
        value: '$15,000',
        probability: 0.6,
        stage: 'Discovery',
        expectedClose: 'Nov 20, 2025',
        owner: 'Emily Johnson',
        DataStatus: 'Upsell'

    },
    {
        opportunity: 'Annual Contract Renewal',
        description: 'Standard annual renewal – no expansion anticipated',
        value: '$15,000',
        probability: 0.5,
        stage: 'Negotiation',
        expectedClose: 'Oct 15, 2025',
        owner: 'Sarah Johnson',
        DataStatus: 'Cross-sell'

    },
    {
        opportunity: 'New API Integration',
        description: 'Prospect seeks integration with third-party marketing tools',
        value: '$8,500',
        probability: 0.4,
        stage: 'Qualification',
        expectedClose: 'Dec 01, 2025',
        owner: 'Michael Lee',
        DataStatus: 'Upsell'

    },
    {
        opportunity: 'Enterprise Security Audit',
        description: 'Large client requests SOC2 compliance audit',
        value: '$22,000',
        probability: 0.3,
        stage: 'Discovery',
        expectedClose: 'Nov 30, 2025',
        owner: 'Anita Patel',
        DataStatus: 'Cross-sell'

    },
]

const OpportunitiesTab = () => {
    const [pageSize, setPageSize] = useState(20)
    const [currentPage, setCurrentPage] = useState(1)

    // Pagination logic
    const totalCount = opportunitiesData.length
    const totalPages = Math.ceil(totalCount / pageSize)

    const rangeSize = 3
    const startRange = Math.floor((currentPage - 1) / rangeSize) * rangeSize + 1
    const endRange = Math.min(startRange + rangeSize - 1, totalPages)

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page)
        }
    }

    const paginatedOpportunities = opportunitiesData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    )

    const handlePageSizeChange = (e) => {
        setPageSize(Number(e.target.value))
        setCurrentPage(1)
    }

    return (
        <div>
            <div className="chart-card">
                <div className="flex items-center justify-between flex-wrap gap-2 border-b pb-2">
                    <h2 className="text-[20px] font-semibold !border-none">Revenue Opportunities</h2>
                    <button className="btn-light-blue flex items-center gap-2">
                        {addNewTrentIcon} Add New Opportunity
                    </button>
                </div>

                <div className="w-full overflow-auto mt-4 rounded-lg max-h-[300px]">
                    <table className="min-w-[800px] w-full table-auto">
                        <thead className="bg-[#F1F6FF]">
                            <tr>
                                <th className='max-w-[290px] min-w-[250px]'>Opportunity</th>
                                <th>Value</th>
                                <th>Probability</th>
                                <th>Stage</th>
                                <th>Expected Close</th>
                                <th>Owner</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedOpportunities.map((opp, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="font-medium max-w-[290px] min-w-[250px]">
                                        <h6>
                                            {opp.opportunity}
                                        </h6>
                                        <p>
                                            {opp.description}
                                        </p>
                                        <span class="color-label w-fit bg-[#DBE9FF]  text-[#4285F4]">{opp.DataStatus}</span>
                                    </td>
                                    <td>{opp.value}</td>
                                    <td>
                                        <div className="w-16 h-2 bg-gray-200 inline-block rounded">
                                            <div
                                                className="h-2 bg-blue-500 rounded"
                                                style={{ width: `${opp.probability * 100}%` }}
                                            />
                                        </div>
                                        <span className="ml-1">{`${opp.probability * 100}%`}</span>
                                    </td>
                                    <td>
                                        <span
                                            className={`color-label ${opp.stage === 'Proposal'
                                                ? 'bg-[#FFF1E8] text-[#F35325]'
                                                : opp.stage === 'Discovery'
                                                    ? 'bg-[#F1FFEB] text-[#52C41A]'
                                                    : opp.stage === 'Negotiation'
                                                        ? 'bg-yellow-100 text-yellow-700'
                                                        : 'bg-gray-100 text-gray-700'
                                                }`}
                                        >
                                            {opp.stage}
                                        </span>
                                    </td>
                                    <td>{opp.expectedClose}</td>
                                    <td>{opp.owner}</td>
                                    <td className="">
                                        <div className="space-x-2 flex">
                                            <button className="color-label border">Edit</button>
                                            <button className="color-label border">View</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* Bottom */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                <div className="chart-card w-full">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">Pipeline Summary</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="chart-card !shadow-none">
                            <p className="mb-2 text-sm ">Total Pipeline Value</p>
                            <p className="text-blue-600 text-xl font-bold mb-0">$77,000</p>
                        </div>
                        <div className="chart-card !shadow-none">
                            <p className="mb-2 text-sm">Weighted pipeline</p>
                            <p className="text-blue-600 text-xl font-bold mb-0">$67,000</p>
                        </div>
                    </div>
                </div>
                <div className="chart-card w-full">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">Activity and engagement</h2>
                    <div className="chart-card !shadow-none !border-none">
                        <p className="text-blue-600 text-xl font-bold mb-3">$77,000</p>
                        <p className="mb-3 text-sm ">Total Pipeline Value</p>
                        <div className="flex items-center gap-2">
                            <div class="w-full h-[10px] bg-gray-100 rounded">
                                <div class="h-[10px] bg-green-500 rounded" style={{ width: "58%" }}></div>
                            </div>
                            58%
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OpportunitiesTab
